import DataGrid from 'components/DataGrid';
import { useTicketSoldList } from '../../hooks/useTicketSold';
import { Grid } from '@mui/material';
import { I18n } from 'utilities/utilities';
import { BtnClear, BtnSearch } from 'components/Button/ButtonAll';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import { FormProvider } from 'react-hook-form';
import { useMemo, useState } from 'react';
import { MultipleSelectItem } from 'components/Input/Select/MultipleSelectItem';

export const TicketSoldList = () => {
 
    //#region Hook
    const {
        dataColumnSoldTicket,
        formSearch,
        getTable,
        onDelete,
        dataRow,
        loadingTable,
        lstOptionMuseum,
        lstStatus,
        handleClearSearch,
        userType,
        nPrmUser,
        isView
    } = useTicketSoldList()
    // #endregion
    const [startDate, setStartDate] = useState(null);

    const dataColumn = useMemo(() => {
        let data = dataColumnSoldTicket;
        if (userType === 1) {
            data.splice(3, 1);
        }
        return data;
    }, [dataColumnSoldTicket, userType])

    return (
        <Grid container spacing={1} justifyContent={'flex-start'}>
            <Grid item xs={12} >
                <FormProvider {...formSearch}>
                    <Grid container spacing={2} justifyContent={"flex-end"} alignItems={"start"}>
                        {userType !== 1 && nPrmUser === 2 && <Grid item xs={12} sm={4} md={5}>
                            <MultipleSelectItem
                                id={"arrMuseum"}
                                name={"arrMuseum"}
                                label={`ชื่อพิพิธภัณฑ์`}
                                required={false}
                                options={lstOptionMuseum}
                                limitTag={1}
                            />
                        </Grid>}
                        <Grid item xs={12} sm={4} md={2}>
                            <DatePickerItem
                                id={`nStartDate`}
                                name={`nStartDate`}
                                label={`${I18n.SetText("Ticket.DateSoldStart")}`}
                                fullWidth
                                onChange={(e) => {
                                    setStartDate(e);
                                    if (e) {
                                        formSearch.setValue("sDateEnd", null);
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <DatePickerItem
                                id={`nEndDate`}
                                name={`nEndDate`}
                                label={`${I18n.SetText("Ticket.DateSoldEnd")}`}
                                minDate={startDate}
                                fullWidth
                                disabled={false}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <MultipleSelectItem
                                id={"arrStatusId"}
                                name={"arrStatusId"}
                                label={`${I18n.SetText("Ticket.Status")}`}
                                required={false}
                                options={lstStatus}
                            />
                        </Grid>
                        <Grid item xs={12} md={'auto'}>
                            <Grid container spacing={1} direction="row" justifyContent="center" alignItems="center" >
                                <Grid item>
                                    <BtnClear id={"btn-clear"} IsCircleWithOutText onClick={() => handleClearSearch()} />
                                </Grid>
                                <Grid item>
                                    <BtnSearch id={"btn-search"} IsCircleWithOutText onClick={() => getTable(dataRow)} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </FormProvider>
            </Grid>
            <Grid item xs={12} >
                <DataGrid
                    columns={dataColumn}
                    isShowCheckBox={!isView && dataRow.arrRows.length !== 0}
                    rows={dataRow}
                    isLoading={loadingTable}
                    onLoadData={getTable}
                    isHiddenFooter={dataRow.arrRows.length === 0}
                    onDelete={onDelete}
                    sTableID='gtWithdraw'
                    isHiddenToolHead
                    onRowSelectable={(p) => p.row.isAllowDelete}
                    />
            </Grid>
        </Grid>
    )
}
